import React, { useState, useEffect } from "react";
import { Button, Row, Col, Rate, Input, Upload, message } from "antd";
import "./UploadEmployeepic.css";
import {
  SearchOutlined,
  ArrowLeftOutlined,
  PlusOutlined,
  LoadingOutlined,
  DeleteOutlined
} from "@ant-design/icons";
import MediaQuery from "react-responsive";
import { useLocation } from "react-router-dom";
import history from "../../../routes/history";
import ImgCrop from "antd-img-crop";
import { fetchToken, triggerAfterUpload } from "../../../API/API";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { getCompanyProfileDetails } from "../../../redux/actions";
import DeleteImage from '../../../assets/icons/DeleteImage.svg'
import { getImage } from "../../../utilities/storageOperations/downloadURL";
import TopAlert from "../../../components/TopNotification/TopAlert";
import Uploadbanner from "../../Conversations/components/ChatCard/components/Uploadbanner/Uploadbanner";

export default function UploadEmployeepic() {
  const BackendApiBaseUrl = process.env.REACT_APP_API_URL;
  const dispatch = useDispatch();
  const [dimensions, setDimensions] = useState(window.innerWidth);
  const [imageUrl, setimageUrl] = useState("");
  const [loading, setLoading] = useState(false);
     const [fileList1, setFileList1] = useState()
  const [RequestKey, setRequestKey] = useState("");
  const [FileSize, setFileSize] = useState();
  const [error, setError] = useState("");
  const [fileSizeCheck, setFileSizeCheck] = useState(false);
  const [fileTypeCheck, setFileTypeCheck] = useState(false);
  const [CorruptedFileCheck, setCorruptedFileCheck] = useState();
  const resp = useSelector(
    (state) => state.getCompanyProfileDetailsReducer.resp
  );

  useEffect(() => {
    setDimensions(window.innerWidth);
  }, [window.innerWidth]);

  useEffect(() => {
    dispatch(getCompanyProfileDetails());
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setFileSizeCheck(false);
      setFileTypeCheck(false);
    }, 2200);
  }, [fileSizeCheck, fileTypeCheck]);

  const onChange = ({ fileList: newFileList }) => {
    // console.log('Inside File On Change', newFileList,CorruptedFileCheck)
    if(CorruptedFileCheck){
      setFileList1(null);
      
    }
    else{
      setFileList1(newFileList);
    }
  };

  const handleBeforeUpload = (file) => {
    setLoading(true);
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            let image = document.createElement("img");
            image.src = event.target.result;

            image.onload = () => {
                if (
                    file.type !== "image/png" &&
                    file.type !== "image/jpeg" &&
                    file.type !== "image/jpg" ||
                    file.name.toLowerCase().endsWith(".jfif")
                ) {
                    setFileTypeCheck(true);
                    setLoading(false);
                    reject();
                } else if (file.size > 10000000) {
                    setFileSizeCheck(true);
                    setLoading(false);
                    reject();
                } else {
                    resolve(file);
                    setCorruptedFileCheck(false);
                }
            };

            image.onerror = () => {
                reject(new Error("Invalid image file"));
                setFileTypeCheck(true);
                setLoading(false);
                setCorruptedFileCheck(true);
            };
        };

        reader.readAsDataURL(file);
    });
};

  const uploadImage = async (file) => {
    setLoading(true);
    const headers = await fetchToken();
    const payload = {
      type: "albums",
      contentType: file.type,
      albums: "people",
    };
    const imageUrl = `${BackendApiBaseUrl}/upload`;
    const data = await axios.post(imageUrl, payload, { headers });
    var Key = data.data.Key;
    await axios.put(data.data.uploadURL, file).then((res) => {
      setLoading(false);
    });
    await triggerAfterUpload(data?.data?.Key); // Trigger after upload actions
    getPicture(Key.split("/")[3]);
    setRequestKey(Key);
    setFileSize(file.size);
    setLoading(false);
  };

  const getPicture = (Key) => {
    var url = Key;
    if (url !== null) {
      setimageUrl(`${process.env.REACT_APP_S3_URL}/content/pics/albums/${url}`);
    }
  };

  return (
    <>
      <div
        className="upload_main_cont "
        style={{ display: "flex", justifyContent: "center" }}
      >
        {fileTypeCheck && (
          <TopAlert
            display={"flex"}
            title={
              "Cannot open the this file. The file may be corrupt, or in an unsupported format."
            }
            type="warning"
          />
        )}
        {fileSizeCheck && (
          <TopAlert
            display={"flex"}
            title={"File size should not exceed 10MB"}
            type="warning"
          />
        )}
        <div className="uploademployeepic-respcont">
          <ArrowLeftOutlined
            className="uploademployeepic-back uep-center"
            onClick={() => history.goBack()}
          />
          <div className="uploademployeepic-subconnt">
            <div className="uploademployeepic-heading">
            Add your employee’s headshot
            </div>
            <div className="uploademployeepic-txt">
            Showcase who your employee with their favorite headshot of them.
            </div>
            <div >
            <ImgCrop className="upload" rotate>
                <div >
                  <Upload
                    action={uploadImage}
                    beforeUpload={handleBeforeUpload}
                    onChange={onChange}
                    maxCount={1}
                    accept="image/png, image/jpeg, image/jpg"
                    showUploadList={false}
                  >
           {imageUrl ? (
  <div className="uploademployeepic-circle" style={{ position: "relative", display: "inline-block" }}>
    <img src={imageUrl} alt="Uploaded" style={{ width: "100%", borderRadius: "8px" ,height:'100%'}} />
    <img 
      src={DeleteImage} 
      alt="Delete image" 
      className="custom-delete-icon"
      style={{
        position: "absolute",
        top: "5px",
        right: "5px",
        width: "24px",
        height: "24px",
        cursor: "pointer"
      }} 
      onClick={(event) => {
        event.stopPropagation(); 
        setimageUrl("");
      }}
    />
  </div>
) : (
  <Uploadbanner  width={'150'} height={'150'} aspectRatio={'1:1'} />
)}
 
                  </Upload>
                </div>
              </ImgCrop>
            </div>
            <span style={{ color: "red" }}> {error}</span>
          </div>
          <div className="uploademployeepic-btndiv">
            <button
              className="uploademployeepic-next-btn"
              onClick={() => {
                if (imageUrl) {
                  history?.replace({
                    pathname: "/companyprofile/addemployee/empdetails",
                    state: {
                      type: "Update",
                      Key: RequestKey.split("/")[3],
                      FileSize: FileSize,
                      Name: "",
                      Title: "",
                      Description: "",
                      WorkCulture: "",
                    },
                  });
                } else {
                  setError("Please upload the picture.");
                }
              }}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
